import React, { useState, useEffect, useCallback, useContext } from 'react';
//import { Amplify, Auth } from 'aws-amplify';
import { ConfigurationContext } from './ConfigurationContext';
import { encryptAES } from '../helpers/functions';
import axios from 'axios';
/*
Amplify.configure({
    Auth: {
        identityPoolId: process.env.REACT_APP_identityPoolId,
        region: process.env.REACT_APP_region,
        identityPoolRegion: process.env.REACT_APP_identityPoolRegion,
        userPoolId: process.env.REACT_APP_userPoolId,
        userPoolWebClientId: process.env.REACT_APP_userPoolWebClientId,
        authenticationFlowType: process.env.REACT_APP_authenticationFlowType,
    }
});
*/
export const AuthContext = React.createContext({});

export const AuthProvider = ({ children }) => {

    const { setColors,
            getMenu } = useContext(ConfigurationContext);
    
    const [ isAuth, setIsAuth ] = useState(null);
    const [ isAuthLoading, setIsAuthLoading ] = useState(false);

    const signInEncrypted = useCallback(async (username, password) => {

        setIsAuthLoading(true);
        
        let username_ = encryptAES("dots_"+username);
        let password_ = encryptAES(password);

        localStorage.removeItem('access_token');
        localStorage.removeItem('username');
        
        console.log(username_, password_)
        axios.post(`${process.env.REACT_APP_BASE_URL}/onepanel/user_login_encrypted`, {}, {
        headers: {
            'user_login': username_,//encryptAES('sp_'+username),
            'password': password_//encryptAES(password),
        }
        })
        .then(response => {
            
            console.log("🩵", response);
            
            localStorage.setItem('username', username_);
            localStorage.setItem('access_token', response.data.user.IdToken);
            localStorage.setItem('refresh_token', response.data.user.RefreshToken)

            setIsAuthLoading(false);
            setIsAuth(true);
            getConfiguration();

            //setSession(encryptAES(response.data.user.session));
        }).catch(err => {
            console.log(err);
        })

    })



    const signIn = useCallback(async (username, password) => {

        signInEncrypted(username, password);

        /*
        localStorage.removeItem('access_token');
        try {
            setIsAuthLoading(true);

            //const user = await Auth.signIn(username, password);
            const user = signInEncrypted(username, password);
            
            console.info("USER", user, user.signInUserSession.idToken.jwtToken);
            localStorage.setItem('access_token', user.signInUserSession.idToken.jwtToken);

            setIsAuthLoading(false);
            setIsAuth(true);
            getConfiguration();
            

            
        } catch (error) {
            setIsAuthLoading(false);
            return {success: false, message: error.message};
        }
        */
    }, []);

    const signOut = useCallback(async () => {
        
        try {

            //await Auth.signOut();
            setIsAuthLoading(false);
            setIsAuth(false);
            localStorage.removeItem('users_filters');
            localStorage.removeItem('access_token');
            localStorage.removeItem('benefits_filters');
            localStorage.removeItem('courses_filters');
            localStorage.removeItem('posts_filters');
            localStorage.removeItem('products_filters');
            localStorage.removeItem('stores_filters');
            localStorage.removeItem('survey_filters');

        } catch (error) {


        }
    }, []);

    const getConfiguration = useCallback(async () => {

		setColors({
            backgroundColor: { primary: "25,132,197", secondary: "244,106,155"},
            fontColor: { primary: "10,10,10", secondary: "179,61,198"},//39,174,239
            borderColor: { primary: "237,191,51", secondary: "237,225,91"},
            buttonColor: { normal: "5,132,197", hover: "10,105,163", fontNormal: "255,255,255", fontHover: "255,255,255"},
        });

	}, []);

    useEffect(() => {
        if(localStorage.getItem('access_token')){
            setIsAuth(true);
            getMenu();
        }else{
            setIsAuth(false);
        }
    
      return () => {}

    }, [localStorage.getItem('access_token')])
    

    return (
    <AuthContext.Provider 
        value={{ 
            isAuth,
            isAuthLoading,
            signIn,
            signOut
        }}>
        {children}
    </AuthContext.Provider>
    );
};
